import axios from 'axios';

class HttpApi {
    public static init(language: string) {
        axios.defaults.headers['Accept-Language'] = language;
    }
}

export default HttpApi;
